'use client';

import { c as _c } from "react/compiler-runtime";
import { Descope } from '@descope/nextjs-sdk';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { ROUTES } from '@/routes';
import classNames from '@/utils/classNames';
import type { ReactNode } from 'react';
const AuthFlow = t0 => {
  const $ = _c(19);
  const {
    redirectAfterSuccess,
    onSuccess,
    flowId: t1,
    loadingFallback
  } = t0;
  const flowId = t1 === undefined ? "sign-up-or-in" : t1;
  const {
    push
  } = useRouter();
  const [isReady, setIsReady] = useState(false);
  let t2;
  if ($[0] !== isReady || $[1] !== loadingFallback) {
    t2 = loadingFallback && !isReady ? <div aria-hidden={true} className="w-full">{loadingFallback}</div> : null;
    $[0] = isReady;
    $[1] = loadingFallback;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !isReady && "h-0 overflow-hidden";
  let t4;
  if ($[3] !== t3) {
    t4 = classNames("w-full", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsReady(true);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onSuccess || $[7] !== push || $[8] !== redirectAfterSuccess) {
    t6 = async e => {
      await onSuccess(e?.detail);
      const target = redirectAfterSuccess ?? ROUTES.APP_ROOT;
      if (target.startsWith("https://") || target.startsWith("http://")) {
        window.location.href = target;
      } else {
        push(target);
      }
    };
    $[6] = onSuccess;
    $[7] = push;
    $[8] = redirectAfterSuccess;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== flowId || $[11] !== t6) {
    t7 = <Descope flowId={flowId} onReady={t5} onSuccess={t6} restartOnError={true} />;
    $[10] = flowId;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t8) {
    t9 = <div className="flex grow flex-col">{t2}{t8}</div>;
    $[16] = t2;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default AuthFlow;